const $ = jQuery.noConflict();
$(function(){
$('.center').slick({
  infinite: true,
  arrows: false,
  dots: true,
  adaptiveHeight: true,
  centerMode: true, //要素を中央寄せ
  centerPadding: '20%', //両サイドの見えている部分のサイズ
  autoplay: true,
  speed: 500,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        centerPadding: '10%'
      }
    },
    {
      breakpoint: 750,
      settings: {
        centerPadding: '0'
      }
    }
  ]
});
});